/**
 * Regra: esconde o select só quando não há nenhuma opção para escolher —
 * `SelectCentroCusto` e `SelectLocais` (#1925). Enquanto a busca ainda está
 * em voo, `totalDeOpcoes` é 0 mesmo que existam opções por vir; `jaBuscou`
 * evita esconder e "pipocar" de volta quando o dado chega. `SelectEmpresa`
 * e `SelectEmpresas` continuam com a regra antiga (`<= 1`), de propósito —
 * não usam esta função.
 */
export function deveExibirSelect(
    totalOpcoes: number,
    escondeSemOpcoes = false,
    jaBuscou = true,
): boolean {
    return !(escondeSemOpcoes && jaBuscou && totalOpcoes === 0)
}
